import { render, staticRenderFns } from "./SingleResponse.vue?vue&type=template&id=82308a30&scoped=true&"
import script from "./SingleResponse.vue?vue&type=script&lang=js&"
export * from "./SingleResponse.vue?vue&type=script&lang=js&"
import style0 from "./SingleResponse.vue?vue&type=style&index=0&id=82308a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82308a30",
  null
  
)

export default component.exports